export const domainInputPlaceholder = 'e.g. www.example.com';
